import Vue from 'vue';

export default {
    namespaced: true,
    // -----------------------------------------------------------------
    actions: {
        list: () => {
            return Vue.api.get(`lists/companies`)
            .then(response => {
                return response.data.data
            })
            .catch(error => { throw error.response.data.error })
        }
    }
}
